import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
//Action
import { loadingSet } from '../action/uiAction';


function* listGet(action) {
  yield put(loadingSet(true));

  let page = (action.payload.page) ? action.payload.page : 1;

  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('category', payload.category);
    params.append('page', page);
    return axios.post(config.apiUri + "articlesListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "ARTICLES_LIST_SET",
        payload: {
          category: res.data.category,
          childCategory: res.data.childCategory,
          breadcrumb: res.data.breadcrumb,
          list: res.data.list,
          page: page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* itemGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('id', payload.id);
    return axios.post(config.apiUri + "articlesItemApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "ARTICLES_ITEM_SET",
        payload: {
          id: action.payload.id,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('ARTICLES_LIST_GET', listGet),
  takeLatest('ARTICLES_ITEM_GET', itemGet),
];

export default saga;
